<template>
    <div>      
      <b-modal
          id="modal-form"
          ok-only
          centered
          size="md"
          content-class="shadow"
          hide-footer
        >
        <template #modal-title> <div style="font-size:24px; font-weight:600;">{{ createMode ? 'Tambah' : 'Ubah'}} Kategori</div></template>
          <div >
            <b-form-row>
              <b-col>
                <b-row class="d-flex align-items-center">
                  <b-col sm="5" >
                    <p style="font-weight: 600; margin:0px;">Parent Kategori</p>
                  </b-col>:<b-col sm="6">
                      <b-form-select style="max-width: 478px;" v-model="dataSubmit.parent_id">
                        <b-form-select-option value="1">Informasi</b-form-select-option>
                        <b-form-select-option value="2">Kegiatan</b-form-select-option>
                        <!-- <b-form-select-option value="0" disabled>Silahkan Pilih Parent</b-form-select-option> -->
                        <!-- <b-form-select-option :value="item.id" v-for="(item,index) in list" :key="index">{{item.name}}</b-form-select-option> -->

                      </b-form-select> 
                  </b-col>
                </b-row>  
                <b-row class="d-flex align-items-center pt-1">
                  <b-col sm="5" >
                    <p style="font-weight: 600; margin:0px;">Kategori</p>
                  </b-col>:<b-col sm="6">
                      <b-form-input v-model="dataSubmit.name" placeholder="Masukan Kategori Konten"></b-form-input>
                  </b-col>
                </b-row>  
              </b-col>
            </b-form-row>
            <div class="text-center">
              <b-button
                variant="outline-primary"
                class="mt-16 text-center mr-5"
                @click="$bvModal.hide('modal-form')"
              >
                Batal
              </b-button>
              <b-button
                variant="primary"
                class="mt-16 text-center"
                @click="submitForm()"
              >
                {{ createMode ? 'Tambah' : 'Ubah'}}
              </b-button>
            </div>
          </div>
      </b-modal>
      <b-modal
        id="formKonfirmasi"
        ok-only
        centered
        size="md"
        content-class="shadow"
        hide-header
        hide-footer
      >
        <div>
          <b-container>
            <p style="font-size:18px; margin-top:20px;">
              Apakah anda yakin ingin Menghapus Kategori?
            </p>
          </b-container>
          <div class="text-center">
            <b-button
              variant="outline-secondary"
              class="mt-16 text-center mr-5"
              @click="$bvModal.hide('formKonfirmasi')"
            >
              Tidak
            </b-button>
            <b-button
              variant="danger"
              class="mt-16 text-center"
              @click="deleteData()"
            >
              Yakin
            </b-button>
          </div>
        </div>
      </b-modal>
      <b-row class="mt-5">
          <b-col class="d-flex align-items-center justify-content-between">
            <span style="font-size:16px; font-weight:bold;">Kategori Konten</span>
            <div>
                <b-button
                size="sm"
                variant="primary"
                @click="createJenis()"
              >
                <v-icon
                  style="color:white;"
                  small
                >mdi-plus-box</v-icon>
                Tambah Kategori
              </b-button>
            </div>
          </b-col>
        </b-row>
        <div
            class="table-responsive mt-4"
            style="border-radius:15px;"
          >
            <table
              class="
            table
            table-head-custom
            table-vertical-center
            table-head-bg
            table-bordered
          "
              style="font-size:14px !important;"
            >
              <thead>
                <tr class="text-left">
                  <th style="width: 20px" class="text-capitalize">No.</th>
                  <th style="min-width: 50px" class="text-capitalize">Jenis Konten</th>
                  <th style="min-width: 50px" class="text-capitalize">Aksi</th>
                </tr>
              </thead>
              <!-- <tbody v-if="list.length == 0">
                  <template>
                      <tr>
                          <td colspan="6"> -- Tidak ada permohonan -- </td>
                      </tr>
                  </template>
              </tbody> -->
              <tbody style="background: #FFFFFF;">
                <template v-for="(item, i) in list">
                  <tr v-bind:key="i">
                    <td >
                      <span class="
                      text-dark-75
                      font-weight-bolder
                      d-block
                      font-size-lg
                    ">{{ (i+1) + ((currentPage-1)*perPage)}}</span>
                    </td>
                    <td class="text-left">
                      <span  class="
                      text-dark-75
                      font-weight-bolder
                      text-left
                      font-size-lg
                    "> {{ item.name}}
                      </span>
                    </td>
                    <td>
                       <section>
                        <b-button variant="danger" size="sm" style="padding:5px" class="mr-1" @click="confirmDelete(item.id)">
                            <v-icon style="color:white;padding:0px;" small>mdi-trash-can-outline</v-icon>
                        </b-button>
                        <b-button variant="primary" size="sm" style="padding:5px" class="mr-1" @click="editJenis(item)">
                            <v-icon style="color:white;padding:0px;" small>mdi-pencil</v-icon>
                        </b-button>
                      </section>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <b-row>
            <b-col class="d-flex justify-content-end">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                aria-controls="my-table"
              ></b-pagination>
            </b-col>
          </b-row>
    </div>
</template>
<script>
import Swal from "sweetalert2";
export default {
  name: "Kategori",
  data() {
    return {
      list: [],
      lisList: false,
      listKontenKategori: [],
      dataSubmit: { name: null, parent_id: 0},
      idnya: null,
      createMode: true,
      currentPage: 1,
      currentOffset: 0,
      totalRows: 0,
      perPage: 20,
      query: {},
    };
  },
  mounted() {
    this.fetchData()
  },
  watch:{
    activeTab(/*to*/){
      
    }
  },
  methods: {
    createJenis(){
      this.createMode = true
      this.dataSubmit = { name: null, parent_id: 0}
      this.$bvModal.show('modal-form')
    },
    editJenis(data){
      this.idnya = data.id
      this.createMode = false
      this.dataSubmit = { name: data.name, parent_id: data.parent_id}
      this.$bvModal.show('modal-form')
    },
    fetchData(){
      this.lisList = true
      this.listKontenKategori = []
      this.query = {
        offset: this.currentOffset * 20,
        limit: 20,
        skip: 0,
        where: {
          terhapus: false
        }
      };
      this.itemCountGet(this.query)
      this.$store
        .dispatch("listKategoriCMS",this.query)
        .then((res) => {
          this.list = res.data
          this.lisList = false
        })
    },
    paginateKategoriKonten() {
      // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
      this.list = this.listKontenKategori.slice((this.currentPage - 1) * this.perPage, this.currentPage * this.perPage);
    },
    async itemCountGet() {
      // if(q && q.bk || q.ss || q.ck || q.jo || q.sk || q.no){
      this.$store
        .dispatch("listKategoriCMSCount")
        .then((res) => {
          this.totalRows = res.data.count
      })
    },
    submitForm(){
      let data = {
        "name": this.dataSubmit.name,
        "parent_id": Number(this.dataSubmit.parent_id)
      }
      if(this.createMode ){
        this.$store
        .dispatch("submitKategoriCMS", data)
        .then(() => {
          Swal.fire({
            title: "Data berhasil disimpan",
            text: "",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Lanjut",
          }).then(() => {
            this.$bvModal.hide('modal-form')
            this.dataSubmit = ''
            this.fetchData()
          })
        })
      } else{
        this.$store
        .dispatch("submitPatchKategoriCMS", [data, this.idnya])
        .then(() => {
          Swal.fire({
            title: "Data berhasil Diubah",
            text: "",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Lanjut",
          }).then(() => {
            this.$bvModal.hide('modal-form')
            this.dataSubmit = ''
            this.fetchData()
          })
        })
      }
      
    },
    deleteData(){
      this.$store
        .dispatch("deleteKategoriCMS", this.idnya)
        .then(() => {
          Swal.fire({
            title: "Data berhasil dihapus",
            text: "",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Lanjut",
          }).then(() => {
            this.$bvModal.hide('formKonfirmasi')
            this.fetchData()
          })
        })
    },
    confirmDelete(id){
      this.idnya = id
      this.$bvModal.show('formKonfirmasi')
    }
  },
  computed: {
    
  }
};
</script>